import { Row, Col } from 'reactstrap';
import {
  onDelete,
  alphabetMask,
  emailMask,
  mobileMask,
  cpfMask,
  badgeMask,
} from '../../helpers/masks';

export const Attendee = ({
  index,
  attendee,
  fillAttendee,
  length,
  t,
  htmlId,
}) => {
  const states = t('attendee.fields.state.options', {
    returnObjects: true,
  });
  return (
    <>
      <h3 className='mb-3'>
        Informações do {length === 1 ? '' : `${index + 1}º`} participante
      </h3>
      <Row className='align-items-end'>
        <Col
          md={6}
          className='mb-3'
        >
          <label
            className='form-label'
            htmlFor={`attendee-${index}-name`}
          >
            <i className='bi bi-person me-2' />
            {t('attendee.fields.name')}
          </label>
          <input
            id={`attendee-${index}-name`}
            className='form-control'
            autoComplete='off'
            value={attendee.name}
            onChange={(e) => {
              const { value } = e.target;
              const newValue = alphabetMask(value);
              fillAttendee('name', newValue, index);
            }}
          />
        </Col>
        <Col
          md={6}
          className='mb-3'
        >
          <label
            className='form-label'
            htmlFor={`attendee-${index}-namebadge`}
          >
            <i className='bi bi-person me-2' />
            {t('attendee.fields.namebadge')}
          </label>
          <input
            id={`attendee-${index}-namebadge`}
            className='form-control'
            autoComplete='off'
            value={attendee.namebadge}
            maxLength={20}
            onChange={(e) => {
              const { value } = e.target;
              const newValue = badgeMask(value);
              fillAttendee('namebadge', newValue, index);
            }}
          />
        </Col>
        <Col
          md={6}
          className='mb-3'
        >
          <label
            className='form-label'
            htmlFor={`attendee-${index}-document`}
          >
            <i className='bi bi-123 me-2'></i>
            {t('attendee.fields.document')}
          </label>
          <input
            type='email'
            id={`attendee-${index}-document`}
            className='form-control'
            name='document'
            autoComplete='off'
            value={attendee.document}
            onChange={(e) => {
              const { value } = e.target;
              const newValue = cpfMask(value);
              fillAttendee('document', newValue, index);
            }}
            onKeyDown={(e) => {
              const newValue = onDelete(e, attendee.document);
              fillAttendee('document', newValue, index);
            }}
          />
        </Col>
        <Col
          md={6}
          className='mb-3'
        >
          <label
            className='form-label'
            htmlFor={`attendee-${index}-email`}
          >
            <i className='bi bi-envelope me-2'></i>
            {t('attendee.fields.email')}
          </label>
          <input
            type='email'
            id={`attendee-${index}-email`}
            className='form-control'
            name='email'
            autoComplete='off'
            value={attendee.email}
            onChange={(e) => {
              const { value } = e.target;
              const newValue = emailMask(value);
              fillAttendee('email', newValue, index);
            }}
          />
        </Col>
        <Col
          md={6}
          className='mb-3'
        >
          <label
            className='form-label'
            htmlFor={`attendee-${index}-mobile`}
          >
            <i className='bi bi-telephone me-2'></i>
            {t('attendee.fields.mobile')}
          </label>
          <input
            id={`attendee-${index}-mobile`}
            className='form-control'
            autoComplete='off'
            value={attendee.mobile}
            maxLength={15}
            onChange={(e) => {
              const { value } = e.target;
              const newValue = mobileMask(value);
              fillAttendee('mobile', newValue, index);
            }}
            onKeyDown={(e) => {
              const newValue = onDelete(e, attendee.mobile);
              fillAttendee('mobile', newValue, index);
            }}
          />
        </Col>
        <Col
          md={6}
          className='mb-3 flex flex-column'
        >
          <label
            className='form-label'
            htmlFor={`attendee-${index}-address`}
          >
            <i className='bi  bi-geo-alt me-2' />
            {t('attendee.fields.address')}
          </label>
          <input
            id={`attendee-${index}-address`}
            className='form-control'
            autoComplete='off'
            value={attendee.address}
            onChange={(e) => {
              const { value } = e.target;
              const newValue = value;
              fillAttendee('address', newValue, index);
            }}
          />
        </Col>
        <Col
          md={6}
          className='mb-3 flex flex-column'
        >
          <label
            className='form-label'
            htmlFor={`attendee-${index}-state`}
          >
            <i className='bi  bi-geo-alt me-2' />
            {t('attendee.fields.state.name')}
          </label>
          <select
            id={`attendee-${index}-state`}
            className='form-control'
            autoComplete='off'
            value={attendee.state}
            onChange={(e) => {
              const { value } = e.target;
              const newValue = value;
              fillAttendee('state', newValue, index);
            }}
          >
            {states.map((state, index) => (
              <option
                key={index}
                value={state.code}
              >
                {state.name}
              </option>
            ))}
          </select>
        </Col>
        <Col
          md={6}
          className='mb-3 flex flex-column'
        >
          <label
            className='form-label'
            htmlFor={`attendee-${index}-city`}
          >
            <i className='bi bi-geo-alt me-2' />
            {t('attendee.fields.city')}
          </label>
          <input
            id={`attendee-${index}-city`}
            className='form-control'
            autoComplete='off'
            value={attendee.city}
            onChange={(e) => {
              const { value } = e.target;
              const newValue = value;
              fillAttendee('city', newValue, index);
            }}
          />
        </Col>
        <Col
          md={6}
          className='mb-3 flex flex-column'
        >
          <label
            className='form-label'
            htmlFor={`attendee-${index}-company`}
          >
            <i className='bi bi-building me-2' />
            {t('attendee.fields.company')}
          </label>
          <input
            id={`attendee-${index}-company`}
            className='form-control'
            autoComplete='off'
            value={attendee.company}
            onChange={(e) => {
              const { value } = e.target;
              const newValue = value;
              fillAttendee('company', newValue, index);
            }}
          />
        </Col>
        <Col
          md={6}
          className='mb-3 flex flex-column'
        >
          <label
            className='form-label'
            htmlFor={`attendee-${index}-role`}
          >
            <i className='bi bi-person-badge me-2' />
            {t('attendee.fields.role')}
          </label>
          <input
            id={`attendee-${index}-role`}
            className='form-control'
            autoComplete='off'
            value={attendee.role}
            onChange={(e) => {
              const { value } = e.target;
              const newValue = value;
              fillAttendee('role', newValue, index);
            }}
          />
        </Col>
      </Row>
      <Row className='align-items-end mt-3'>
        <Col className='mb-3'>
          <div className='form-check'>
            <input
              id={`attendee-${index}-term1`}
              className='form-check-input'
              type='checkbox'
              checked={attendee.term1}
              onChange={(e) => {
                fillAttendee('term1', !attendee.term1, index);
              }}
            ></input>
            <label className='form-check-label'>
              <p className='text-justify'>
                {t('attendee.fields.term1.start')}{' '}
                <a
                  href={t('attendee.fields.term1.link_url')}
                  target={'_blank'}
                  rel='noreferrer'
                >
                  {t('attendee.fields.term1.link_text')}
                </a>{' '}
                {t('attendee.fields.term1.end')}
              </p>
            </label>
          </div>
        </Col>
      </Row>
      <Row className='align-items-start'>
        <Col className='mb-3'>
          <div className='form-check'>
            <input
              id={`attendee-${index}-term2`}
              className='form-check-input'
              type='checkbox'
              checked={attendee.term2}
              onChange={(e) => {
                fillAttendee('term2', !attendee.term2, index);
              }}
            ></input>
            <label className='form-check-label'>
              <p className='text-justify'>{t('attendee.fields.term2')}</p>
            </label>
          </div>
        </Col>
      </Row>
      <Row className='align-items-start'>
        <Col className='mb-3'>
          <div className='form-check'>
            <input
              id={`attendee-${index}-term3`}
              className='form-check-input'
              type='checkbox'
              checked={attendee.term3}
              onChange={(e) => {
                fillAttendee('term3', !attendee.term3, index);
              }}
            ></input>
            <label className='form-check-label'>
              <p className='text-justify'>{t('attendee.fields.term3')}</p>
            </label>
          </div>
        </Col>
      </Row>
    </>
  );
};
